export function initAccordion(container = document) {
  container.querySelectorAll('.accordion').forEach(accordion => {
    const triggers = Array.from(accordion.querySelectorAll('.accordion__trigger'));

    // À l'init, marquer inert tous les panneaux qui ne sont pas déjà ouverts
    triggers.forEach(trigger => {
      const panelId = trigger.getAttribute('aria-controls');
      const panel = accordion.querySelector(`#${panelId}`);
      if (panel && trigger.getAttribute('aria-expanded') !== 'true') {
        panel.setAttribute('inert', '');
      }
    });

    triggers.forEach((trigger, index) => {
      // Clic pour ouvrir/fermer
      trigger.addEventListener('click', () => {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        const panelId = trigger.getAttribute('aria-controls');
        const panel = accordion.querySelector(`#${panelId}`);

        // Fermer tous les panels
        triggers.forEach(t => t.setAttribute('aria-expanded', 'false'));
        accordion.querySelectorAll('.accordion__panel').forEach(p => {
          p.classList.remove('active');
          p.style.overflow = 'hidden';
          p.setAttribute('inert', '');
        });

        // Si c'était fermé, ouvrir celui-ci
        if (!isExpanded) {
          trigger.setAttribute('aria-expanded', 'true');
          panel.classList.add('active');
          panel.removeAttribute('inert');

          // Attendre la fin de la transition avant d'autoriser le débordement
          const duration =
            parseFloat(getComputedStyle(panel).transitionDuration) * 1000 || 300;
          setTimeout(() => {
            panel.style.overflow = 'visible';
          }, duration);
        }
      });

      // Navigation clavier entre triggers (ArrowUp/Down/Home/End)
      trigger.addEventListener('keydown', (event) => {
        let newIndex = index;
        switch (event.key) {
          case 'ArrowDown':
            newIndex = index < triggers.length - 1 ? index + 1 : 0;
            break;
          case 'ArrowUp':
            newIndex = index > 0 ? index - 1 : triggers.length - 1;
            break;
          case 'Home':
            newIndex = 0;
            break;
          case 'End':
            newIndex = triggers.length - 1;
            break;
          default:
            return;
        }
        event.preventDefault();
        triggers[newIndex].focus();
      });
    });
  });
}
